export const accountData = [
  {
    title: "Your Orders",
    desc: "Track, Return or buy things again",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/help/images/gateway/self-service/order._CB660668735_.png",
    link: "",
  },
  {
    title: "Login & Security",
    desc: "Edit login, name and mobile numbers",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/help/images/gateway/self-service/security._CB659600413_.png",
    link: "",
  },
  {
    title: "Prime",
    desc: "View benefits and payment settings",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/ya/images/Prime_clear-bg._CB423472251_.png",
    link: "",
  },
  {
    title: "Gift Cards",
    desc: "View Balance Redeem or Reload cards",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/contact-us/GiftCard_icon_01._CB660349069_.png",
    link: "",
  },
  {
    title: "Your Payments",
    desc: "View All Transactions, manage payment method and settings",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/help/images/gateway/self-service/payment._CB660668735_.png",
    link: "",
  },
  {
    title: "Your Profiles",
    desc: "Manage Add, or remove user profiles for personalized experience",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/help/images/gateway/self-service/account._CB660668669_.png",
    link: "",
  },
  {
    title: "Digital Services and Device Support",
    desc: "TroubleShoot Device Issues",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/help/images/gateway/self-service/digital_devices._CB660668735_.png",
    link: "",
  },
  {
    title: "Your Message",
    desc: "View messages to and from amazon, sellers and buyers",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/help/images/gateway/self-service/fshub/9_messages._CB654640573_.jpg",
    link: "",
  },
  {
    title: "Archived Orders",
    desc: "View and manage Archived Orders: ",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/help/images/gateway/self-service/fshub/10_archived_orders._CB654640573_.png",
    link: "/shipped",
  },
  {
    title: "Your Lists",
    desc: "View modify and share your list or create new ones",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/help/images/gateway/self-service/fshub/11_lists._CB654640573_.png",
    link: "/mylist",
  },
  {
    title: "Customer Service",
    desc: " ",
    img: "https://m.media-amazon.com/images/G/01/x-locale/cs/help/images/gateway/self-service/contact_us._CB659962323_.png",
    link: "",
  },
];
export const accountLinks = {
  ordering: [
    "Your addresses",
    "Your Payments",
    "Your Transactions",
    "Your Amazon profile",
    "Download order reports",
    "1-Click settings",
    "Amazon Fresh settings",
    "Amazon Key settings",
    "Language preferences",
    "Manage saved IDs",
    "Coupons",
    "Product Vouchers",
    "VAT registration number",
  ],
  digitalContent: [
    "All things Alexa",
    "Manage content and devices",
    "Manage Digital Delivery",
    "Your apps",
    "Prime Video settings",
    "Amazon Music settings",
    "Manage Amazon Drive and photos",
    "Twitch settings",
    "Audible settings",
    "Amazon Coins",
    "Digital gifts you've received",
    "Digital and device forum",
    "Comixology settings",
    "Online Learning",
  ],
  memberShip: [
    "Kindle Unlimited",
    "Prime Video Channels",
    "Music Unlimited",
    "Subscribe & Save",
    "Amazon Kids+",
    "Audible membership",
    "Your Essentials",
    "Magazine subscriptions",
    "Other subscriptions",
  ],
  communication: [
    "Email subscriptions",
    "Advertising preferences",
    "Communication preferences",
    "Shipment updates via text",
    "Alexa shopping notifications",
    "Deals Notifications",
    "Videos you've uploaded",
    "Purchase Reminders",
  ],
  shopping: [
    "Buy now, pay over time",
    "Third Party Credit Card Installment",
    "Manage Your Profiles",
    "Rentals by Amazon",
    "Amazon Household",
    "Shop the Kids Store by age",
    "No-Rush rewards summary",
    "Teens Program",
    "Pet Profiles",
    "Shop with Points",
    "Amazon Second Chance",
    "Benefits balance",
  ],
  programs: [
    "Account Linking",
    "Amazon credit cards",
    "Your seller account",
    "Login with Amazon",
    "Amazon Pay",
    "Manage your trade-ins",
    "Amazon Web Services",
    "Amazon tax exemption program",
    "Store Analytics",
    "Your Interests",
    "In-Store Promo Wallet",
  ],
};
